import { match } from "ts-pattern";
import { selectState as ss } from "@bfc-software/pallet";
import type { Async } from "@bfc-software/bfc-web-ui/lib/async-utils";

/**
 * A query's three cases onto a `SelectState`: failed -> `disabled`, loading ->
 * `loading`, loaded -> `ready`.
 *
 * App-side by design: pallet stays free of `Async`, and the copy is app i18n.
 * The caller pre-filters (`mapAsync`) because pallet never filters, and
 * supplies `live` to pick single / multiple / always around the `options`.
 */
export function fromAsync<T extends ss.Item>(
  async: Async<ReadonlyArray<T>>,
  copy: { label: ss.Label; loading: string; empty: string; failed: string },
  live: (options: ss.Options<T>) => ss.LiveState<T>,
): ss.SelectState<T> {
  return match(async)
    .with({ kind: "failed" }, () =>
      ss.disabled({ label: copy.label, reason: copy.failed }),
    )
    .with({ kind: "loading" }, () => live(ss.loading(copy.loading)))
    .with({ kind: "loaded" }, ({ value }) =>
      live(ss.ready({ items: value, emptyLabel: copy.empty })),
    )
    .exhaustive();
}
